/*
    RAVN code 
 */
// Set the end date and time in MST
const  spans = document.querySelectorAll('.countdown-timer')
console.log(spans)
spans.forEach(span => {
    const endDate = new Date(span.dataset.endDate);
    const endTitle = span.dataset.endTitle;
    console.log(endDate.toISOString())
    // Update the countdown every second
    const countdown = setInterval(function() {
    const now = new Date();
    const timeLeft = endDate - now;
        
    // Calculate total hours, minutes, and seconds left
    const totalHours = Math.floor(timeLeft / (1000 * 60 * 60)); // Total hours
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60)); // Remaining minutes
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000); // Remaining seconds

    // Format the time as HH:MM:SS
    const formattedTime = 
        String(totalHours).padStart(2, '0') + ":" + 
        String(minutes).padStart(2, '0') + ":" + 
        String(seconds).padStart(2, '0');

    // Display the result in the specified format
    span.innerHTML = formattedTime;

    // If the countdown is finished, display a message
    if (timeLeft < 0) {
        clearInterval(countdown);
        span.innerHTML = endTitle;
    }

    }, 1000); // Update every second
});

/*
    RAVN code 
 */